export default __webpack_public_path__ + "static/media/03.6538eed4.jpg";